import Radium from '@flipdish/radium';
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import * as Api from '../../Api';
import { Sorted } from '../../Data';
const tinycolor = require('tinycolor2');

interface Props {
  ShowModal: boolean;
  Close: () => any;
  isDark: boolean;
  offset: number;
  number: string;
  prid: number;
  handleNumber: (e: any) => any;
  handleSubmit: () => any;
  PlaceOrderAfterTableSelect: boolean;
  translate: any;
  TableServiceCategory: Api.TableServiceCategory;
  PickupLocationOptions: Api.PickupLocationOption[];
  AppDesignScheme: Api.AppDesignScheme;
}

interface State {}

class TableSelectModal extends React.Component<Props, State> {
  public UNSAFE_componentWillReceiveProps(newProps: Props) {
    if (
      !this.props.ShowModal &&
      newProps.ShowModal &&
      !newProps.number &&
      newProps.PickupLocationOptions &&
      newProps.PickupLocationOptions.length > 0
    ) {
      const firstRealOptionIndex = newProps.PickupLocationOptions.findIndex(
        (pickupLocationOption) => !pickupLocationOption.Value.startsWith('---')
      );

      if (firstRealOptionIndex != -1) {
        newProps.handleNumber({
          target: {
            value: newProps.PickupLocationOptions[
              firstRealOptionIndex
            ].PickupLocationOptionId.toString()
          }
        });
      }
    }
  }

  public render(): JSX.Element {
    const { AppDesignScheme } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      formControl: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {}
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      }
    };

    return (
      <Modal
        show={this.props.ShowModal}
        onHide={this.props.Close}
        className={`${this.props.isDark ? 'dark' : ''}`}
        style={{ marginTop: this.props.offset || 0 }}
      >
        <Modal.Header>
          <p className="clear-margins secondary text-center fd-h3">
            {this.props.translate(`Enter_table_number_${this.props.TableServiceCategory}`)}
          </p>
        </Modal.Header>
        <Modal.Body className="email-modal">
          {this.props.PickupLocationOptions && this.props.PickupLocationOptions.length > 0 ? (
            <select
              className="form-control"
              key="payment-dropdown"
              onChange={this.props.handleNumber}
              value={this.props.number}
              style={styles.formControl}
              autoFocus={true}
            >
              {Sorted(this.props.PickupLocationOptions).map((pickupLocationOption) => (
                <option
                  key={pickupLocationOption.DisplayOrder}
                  value={pickupLocationOption.PickupLocationOptionId.toString()}
                  style={styles.formControl}
                  disabled={pickupLocationOption.Value.startsWith('---')}
                >
                  {pickupLocationOption.Value}
                </option>
              ))}
            </select>
          ) : (
            <input
              className="form-control"
              autoFocus={true}
              pattern="[0-9]*"
              placeholder={this.props.translate(`Table_number_${this.props.TableServiceCategory}`)}
              value={typeof this.props.number === 'number' ? this.props.number : ''}
              onChange={this.props.handleNumber}
              style={styles.formControl}
            />
          )}
        </Modal.Body>
        <Modal.Footer className="flex-justify-center">
          <div className="flex flex-align-center flex-justify-center">
            <button
              className="fd-button fd-button--secondary fd-button--big"
              disabled={typeof this.props.number !== 'number'}
              onClick={
                this.props.PlaceOrderAfterTableSelect ? this.props.handleSubmit : this.props.Close
              }
              key="table-select-button"
              style={
                [
                  styles.buttonSecondary,
                  Radium.getState(this.state, 'table-select-button', ':active')
                    ? styles.buttonActive
                    : Radium.getState(this.state, 'table-select-button', ':hover')
                    ? styles.buttonHover
                    : null
                ] as any
              }
            >
              <p className="clear-margins primary" style={styles.primary}>
                {this.props.prid == 3940 || this.props.prid == 3939
                  ? this.props.translate('Confirm')
                  : this.props.PlaceOrderAfterTableSelect
                  ? this.props.translate('Place_order')
                  : this.props.translate(`Select_table_${this.props.TableServiceCategory}`)}
              </p>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default Radium(TableSelectModal);
